<form class="flex flex-col gap-2 min-w-80" [formGroup]="passwordForm">
  <!-- newPass -->
  <p-password [placeholder]="'field.newPass' | translate" [feedback]="false" formControlName="newPass" 
    [toggleMask]="true" [invalid]="isInvalid('newPass')" [showClear]="f['newPass'].value" inputStyleClass="w-full"></p-password>
  <!-- confirmPass -->
  <p-password [placeholder]="'field.confirmPass' | translate" [feedback]="false" formControlName="confirmPass" 
    [toggleMask]="true" [invalid]="isInvalid('confirmPass')" [showClear]="f['confirmPass'].value" inputStyleClass="w-full"></p-password>
  @if(formSubmitted && f['newPass'].value && f['confirmPass'].value && f['newPass'].value !== f['confirmPass'].value) {
    <p-message severity="error">{{ 'error.password-different' | translate }}</p-message>
  }
  <div class="flex gap-2 justify-end mt-3">
    <p-button [label]="'button.cancel' | translate" styleClass="p-button-secondary" (click)="cancel()"></p-button>
    <p-button [label]="'button.save' | translate" (click)="save()"></p-button>
  </div>
</form>
